import type { ComponentProps, ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface FabProps extends Omit<ComponentProps<typeof Button>, "children"> {
  /** What it does, since the button is an icon alone. Also its tooltip. */
  label: string;
  icon: ReactNode;
}

/**
 * The floating action button (#617): the one main "add" of a list on a phone.
 *
 * Phone only (below `md`), where a full-width action strip above a list costs a
 * row of screen for one small button; from `md` up the screen keeps its toolbar
 * button and this renders nothing. It floats above the pager (the 5rem) and the
 * home indicator, at the right where a thumb rests, and sits under the sheets
 * and drawers (z-20 against their z-50) so an open form is never covered by it.
 */
export function Fab({ label, icon, className, ...props }: FabProps) {
  return (
    <Button
      type="button"
      size="icon-lg"
      aria-label={label}
      title={label}
      className={cn(
        "fixed right-4 bottom-[calc(5rem+env(safe-area-inset-bottom))] z-20 size-14 rounded-full shadow-lg md:hidden [&_svg:not([class*='size-'])]:size-6",
        className,
      )}
      {...props}
    >
      {icon}
    </Button>
  );
}
